import { branch, compose, renderNothing, withHandlers } from 'recompose'
import ActivePromotions from './ActivePromotions'
import { connect } from 'react-redux'
import { setDeletedPromotions } from 'components/QuickAppointmentPage/actions'


const withRemovePromoHandlers = withHandlers({
  removePromo: ({ setDeletedPromotions, fields }) => (index) => {
    const promotionListCopy = JSON.parse(JSON.stringify(fields.getAll()))

    fields.remove(index)
    setDeletedPromotions(promotionListCopy.splice(index, 1))
  }
})

const withRenderNothing = branch(
  ({ fields }) => !fields.getAll().length,
  renderNothing
)

export default compose(
  connect(null, ({ setDeletedPromotions })),
  withRemovePromoHandlers,
  withRenderNothing
)(ActivePromotions)
